/* eslint-disable no-unused-vars */
// Pubsub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { i18n } from "@i18n";
import store from "@store";
import MarkdownIt from 'markdown-it';
import { wdConfigData } from "@/service/wd_app_config.js";
import { addProductLogandTxt, insert_slide_byTemplateFile, shapeIsTextType } from "./gpt_addin_utils";
import { getTemplatePath, getTemplate, needMultiColumnTemplate, getShapeContentSize } from "./template_utils.js";

import { parseOnePageIndentedTextToTree, checkStringIncludeandCompareIntValue } from "./slide_data_utils.js";

// VSTO Host Object
import { default as hostObject_slides } from "../vsto/vsto_slides.js";
import { default as hostObject_shapes } from "../vsto/vsto_shapes.js";
import { sync } from "vuex-pathify";
const vstoMode = store.get("app/vstoMode");

var PowerPoint = window.PowerPoint;

let contentObjArr = []

export function astToText(node, level = 0) {
  let result = '';
  const indent = '  '.repeat(level);
  let nodeType = node.type || node.nodeType;
  let contentObj = {
    level: level,
    nodeType: nodeType,
    text: '',
  }

  switch (nodeType) {
    case 'root':
      node.children.forEach(child => {
        result += astToText(child, level);
      });
      break;
    case 'heading':
      result += `${indent}${node.children.map(child => child.content).join('')}\n`;
      break;
    case 'paragraph':
      result += `${indent}${node.children.map(child => astToText(child, level)).join('')}\n`;
      break;
    case 'text':
      result += node.content;
      break;
    case 'strong':
    case 'link':
    case 'inline':
      result += node.children.map(child => astToText(child, level)).join('');
      break;
    case 'bullet_list':
    case 'ordered_list':
      node.children.forEach(child => {
        result += astToText(child, level);
      });
      break;
    case 'list':
      node.children.forEach(child => {
        result += astToText(child, level);
      });
      break;
    case 'list_item':
      result += `${indent}${node.children.map(child => astToText(child, level + 1)).join('')}\n`;
      break;
    case 'strong_open':
    case 'strong_close':
    case 'hardbreak':
    case 'hr':
    case 'softbreak':
      break;
    default:
      console.log('Unknown node type:', nodeType);
  }
  contentObj.text = result.trim();
  if (nodeType === 'text' || nodeType === 'heading') {
    contentObjArr.push(contentObj);
  }
  return result;
}

export async function add_onepage_slide_general(generateContent) {
  const markdownItAST = require("markdown-it-ast");
  const md = new MarkdownIt();
  const tokens = md.parse(generateContent, {});
  const ast = markdownItAST.makeAST(tokens);
  const jsonOutput = JSON.stringify(ast, null, 2);
  // console.log("jsonOutput", jsonOutput);

  // const mtp = require("markdown-tree-parser");
  // let treeOutput = mtp(generateContent);
  // let treeContent = treeOutput.ast;
  // console.log('generateContent', generateContent);
  // console.log('treeContent', treeContent);

  let slidesDatas = new Array();
  contentObjArr = []
  // for (let i = 0; i < treeContent.length; i++) {
  //   let nodeData = treeContent[i];
  //   if (nodeData.values.length > 0) {
  //     let nodeText = nodeData.values[0].value;
  //     if (nodeData.name === "heading") { // Heading => Title
  //       let nextNode = null;
  //       if (i + 1 != treeContent.length - 1) {
  //         nextNode = treeContent[i + 1];
  //       }
  //       let ret = parseParagraphContentStartWithNodeIndex(i, treeContent);
  //       i = ret.endIndex;
  //       let title = nodeText;
  //       let content = ret.content;
  //       slidesDatas.push({
  //         title: title,
  //         layoutType: "Title and Content",
  //         content: content,
  //         imageUrl: "",
  //       });
  //       store.set("gpt/pptTopic", nodeText);
  //     }
  //   }
  // }
  // console.log('ast :', ast)
  let title = '';
  let content = '';
  for (let i = 0; i < ast.length; i++) {
    let node = ast[i];
    let level = 0;
    const indent = '  '.repeat(level);
    let nodeType = node.type || node.nodeType;
    
    switch (nodeType) {
      case 'root':
        node.children.forEach(child => {
          content += astToText(child, level);
        });
        break;
      case 'heading':
        if (title === '') {
          title = node.children.map(child => child.content).join('');
        } else {
          content += `${indent}${node.children.map(child => child.content).join('')}\n`;
        }
        break;
      case 'paragraph':
        content += `${indent}${node.children.map(child => astToText(child, level)).join('')}\n`;
        break;
      case 'text':
        content += node.content;
        break;
      case 'strong':
      case 'link':
      case 'inline':
        content += node.children.map(child => astToText(child, level)).join('');
        break;
      case 'bullet_list':
      case 'ordered_list':
        node.children.forEach(child => {
          content += astToText(child, level);
        });
        break;
      case 'list':
        node.children.forEach(child => {
          content += astToText(child, level);
        });
        break;
      case 'list_item':
        content += `${indent}${node.children.map(child => astToText(child, level + 1)).join('')}\n`;
        break;
      case 'strong_open':
      case 'strong_close':
      case 'hardbreak':
      case 'hr':
      case 'softbreak':
        break;
      default:
      console.log('Unknown node type:', nodeType);
    }
  }
  slidesDatas.push({
    title: title,
    layoutType: "Title and Content",
    content: content.replace(/\n\s*\n/g, '\n'),
    imageUrl: "",
    hasMaxLevel: findMaxLevel(contentObjArr) || 0,
  });
  store.set("gpt/pptTopic", title);

  let slideData = {}
  for (let i = 0; i < slidesDatas.length; i++) {
    slideData = slidesDatas[i];
    // console.log('slideData: ', slideData)
    let templateName = getTemplate(store.get("gpt/template_contents_type").titleContent, slideData, true)
    let selectedTaskType = store.get('gpt/selectedTaskType')
    if (selectedTaskType && selectedTaskType.id === 'task_one_page_general' && store.get('gpt/currentSelectedTemplateName')) {
      templateName = store.get('gpt/currentSelectedTemplateName')
    }
    // templateName = "textonly_title_content_1"
    const templateUrl = `/layout/${getTemplatePath(slideData, true).titleContent}/${templateName}.pptx`;

    // 这块还没有补全vsto模式下的逻辑
    if (vstoMode) {
      // let index = await hostObject_slides.vsto_insertSlideFromUrl(
      //   `${wdConfigData.baseURLTemplate}/${templateUrl}`
      // );
      // await hostObject_shapes.vsto_updateSlideContent_ClassicCanvans(slideData);
    } else {
      if (selectedTaskType && selectedTaskType.id === 'task_one_page_general' && store.get('gpt/currentSelectedTemplateName')) {
        await confirmSelectedSlideIsSelectedTemplate(slideData, templateUrl)
      } else {
        await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
        await _updateSlideContent(slideData);
      }
      await addProductLogandTxt()
    }
  }
}

export function findMaxLevel(contentObjArr) {
  if (!Array.isArray(contentObjArr)) {
    throw new TypeError('contentObjArr must be an array');
  }

  if (contentObjArr.length === 0) {
    return null; // 或者 return -1; 取决于业务需求
  }

  // 使用 reduce 遍历数组，找到最大的 level
  const maxLevel = contentObjArr.reduce((max, currentObj) => {
    if (currentObj && typeof currentObj.level === 'number') {
      return Math.max(max, currentObj.level);
    }
    return max;
  }, -Infinity);

  return maxLevel !== -Infinity ? maxLevel : null;
}

async function confirmSelectedSlideIsSelectedTemplate(slideData, templateUrl) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let presentation = context.presentation
      let selectedSlides = presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("id");
      await context.sync();
      let selectedId = selectedSlide.id;

      let currentPreviewSlideId = store.get('gpt/currentPreviewSlideId')
      let existCurrentPreviewSlide = false
      presentation.load("slides")
      await context.sync()
      presentation.slides.load("items")
      await context.sync()
      let allSlides = presentation.slides.items

      for (let i = 0; i < allSlides.length; i++) {
        const element = allSlides[i]
        element.load('id')
        await context.sync()
        if (element.id === currentPreviewSlideId) {
          existCurrentPreviewSlide = true
        }
      } 

      if (existCurrentPreviewSlide) {
        if (currentPreviewSlideId && selectedId != currentPreviewSlideId) {
          context.presentation.setSelectedSlides([currentPreviewSlideId])
          await context.sync()
        }
      } else {
        await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
      }
      await _updateSlideContent(slideData)
    });
  } catch (error) {
    console.log("confirmSelectedSlideIsSelectedTemplate")
  }
}

async function _updateSlideContent(slideData) {
  PowerPoint = window.PowerPoint
  // 更改模版中的内容
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      const textShapeTypeArr = ['GeometricShape', 'Placeholder', 'TextBox']
      // shape数组数据
      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        if (textShapeTypeArr.indexOf(shape.type) != -1) {
          // 如果是文本类型的Shape
          if (shapeIsTextType(shape.type, shape.name)) {
            // shape text frame
            let textFrame = shape.textFrame;
            // text range
            textFrame.load("textRange", 'autoSizeSetting');
            await context.sync();
            textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape 
            let textRange = textFrame.textRange;
            textRange.load("$all");
            await context.sync();
            // 增加判断是否是multi-column的内容
            if (needMultiColumnTemplate(slideData, true)) {
              if (shape.name.startsWith("Title") || shape.name.startsWith("标题")) {
                textRange.text = slideData.title;
                await context.sync();
              } else {
                let contentTreeObj = parseOnePageIndentedTextToTree(slideData.content)
                let columnTitleShapeNameTag = '号一级标题'
                let columnContentShapeNameTag = '号二级内容文本'
                if (shape.name.includes(columnTitleShapeNameTag)) {
                  for (let j = 0; j < contentTreeObj.length; j++) {
                    if (checkStringIncludeandCompareIntValue(shape.name, columnTitleShapeNameTag, j+1)) {
                      shape.load("height", "left", "top", "width")
                      await context.sync()
                      let size = getShapeContentSize(true, contentTreeObj.length)
                      // shape.height = 230
                      // shape.left = 66
                      // shape.top = 28.75  
                      shape.width = size.width
                      await context.sync()

                      textRange.text = contentTreeObj[j].content.replace(/\n$/, '');
                      await context.sync();
                    }
                  }
                } else if (shape.name.includes(columnContentShapeNameTag)) {
                  for (let j = 0; j < contentTreeObj.length; j++) {
                    let columnContentArr = contentTreeObj[j].children || [];
                    let columnContent = columnContentArr.map(item => item.content).join('\n');
                    if (checkStringIncludeandCompareIntValue(shape.name, columnContentShapeNameTag, j+1)) {
                      shape.load("height", "left", "top", "width")
                      await context.sync()
                      let size = getShapeContentSize(false, contentTreeObj.length)
                      shape.height = size.height
                      // shape.left = 66
                      // shape.top = 28.75
                      shape.width = size.width
                      await context.sync()

                      textFrame.load('autoSizeSetting')
                      await context.sync()
                      textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape

                      textRange.text = columnContent.replace(/\n$/, '');
                      await context.sync();
                    }
                  }
                } else if (shape.name.includes('动作按钮:')) {
                  // shape.load("height", "left", "top", "width")
                  // await context.sync()
                  // let size = getShapeContentSize(false, contentTreeObj.length)
                  // shape.height = size.height
                  // shape.left = 66
                  // shape.top = 28.75
                  // shape.width = size.width
                  // await context.sync()

                  // textFrame.load('autoSizeSetting')
                  // await context.sync()
                  // textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape

                  // textRange.text = 'Build With NextMind';
                  // await context.sync();
                }
              }
            } else {
              // 更改文本
              if (shape.name.startsWith("Title") || shape.name.startsWith("标题")) {
                textRange.text = slideData.title;
                await context.sync();
              } else if (
                shape.name.startsWith("Content") ||
                shape.name.startsWith("Text") ||
                shape.name.startsWith("内容") ||
                shape.name.startsWith("文本")
              ) {
                shape.load("height", "left", "top", "width")
                await context.sync()
                // height 342.625039370079 width 828 left 66 top 143.75
                if (shape.height < 320) {
                  shape.height = 320
                }

                textRange.load("paragraphFormat")
                await context.sync()
                let paragraphFormat = textRange.paragraphFormat
                paragraphFormat.load("bulletFormat")
                await context.sync()
                let bulletFormat = paragraphFormat.bulletFormat
                bulletFormat.load("visible")
                await context.sync()
                if (slideData.hasMaxLevel && slideData.hasMaxLevel > 1) {
                  bulletFormat.visible = false
                } else {
                  bulletFormat.visible = true
                }
                await context.sync()

                if (slideData.hasMaxLevel && slideData.hasMaxLevel > 1) {
                  textRange.text = slideData.content.replace(/\n$/, '');
                } else {
                  textRange.text = slideData.content.replace(/\n$/, '').replace(/ /g, '');
                }
                await context.sync();

                textRange.load("font", "size", "italic", "color", "bold")
                await context.sync()

                // format textRange style
                const lines = slideData.content.split('\n')
                if (lines.length <= 8) {
                  textRange.font.size = 18  
                } else if (lines.length > 8 && lines.length <= 11) {
                  textRange.font.size = 14
                } else {
                  textRange.font.size = 12
                }
                
                // var textRangeTextFont = textRange.font
                // textRangeTextFont.size = 18
                // await context.sync()
              } else if (shape.name.includes('动作按钮:')) {
                // shape.load("height", "left", "top", "width")
                // await context.sync()
                // let size = getShapeContentSize(false, contentTreeObj.length)
                // shape.height = size.height
                // shape.left = 66
                // shape.top = 28.75
                // shape.width = size.width
                // await context.sync()

                // textFrame.load('autoSizeSetting')
                // await context.sync()
                // textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape

                // textRange.text = 'Build With NextMind';
                // await context.sync();
              }
            }
          }
        }
      }
    });
  } catch (error) {
    console.log("_updateSlideContent", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

function parseParagraphContentStartWithNodeIndex(startIndex, treeContent) {
  let content = "";
  let endIndex = startIndex;
  for (let j = startIndex + 1; j < treeContent.length; j++) {
    endIndex = j
    let contentNode = treeContent[j];
    if (contentNode.values.length > 0) {
      for (let m = 0; m < contentNode.values.length; m++) {
        content += contentNode.values[m].value;
      }
      content += "\r"
    }
  }

  // current node name is Heading and next node name is Heading: compare the current node Level and next node Level
  // current node name is Heading and next node name is not Heading: add 4 spaces before the content
  // current node name is not Heading and next name is not heading: compare the current node Level and next node Level
  // current node name is not Heading and next name is Heading
  return { endIndex, content };
}
